export const ONE_WEEK = 7 * 24 * 60 * 60;
